/* global System */
// register component(s) with react habitat

export default { Footer: () => System.import('./index') }
